import { createFileRoute } from '@tanstack/react-router';
import { TopicShell } from '@/features/Lesson/TopicShell';

export const Route = createFileRoute('/_student/courses/$batchId/topics/$topicId')({
  component: TopicShellRoute,
});

function TopicShellRoute() {
  const { batchId, topicId } = Route.useParams();
  return <TopicShell batchId={batchId} topicId={topicId} />;
}
